<div class="profile-section" id="profileSectionDiv">
  <div class="profile-text" *ngIf="profileName" id="profileTextDiv">
    <div class="profile-name-title" id="profileNameTitleDiv">{{profileNameValue}}</div>
    <h2 class="profile-name-text">{{profileName}}</h2>
  </div>
  <section class="main_section" *ngIf="tabIndex == 0">
    <div class="main_section_headers" id="mainSectionHeadersDiv">
      <svg class="header_icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.75 12C0.948912 12 1.13968 12.079 1.28033 12.2197C1.42098 12.3603 1.5 12.5511 1.5 12.75V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V12.75C22.5 12.5511 22.579 12.3603 22.7197 12.2197C22.8603 12.079 23.0511 12 23.25 12C23.4489 12 23.6397 12.079 23.7803 12.2197C23.921 12.3603 24 12.5511 24 12.75V18C24 18.7956 23.6839 19.5587 23.1213 20.1213C22.5587 20.6839 21.7956 21 21 21H3C2.20435 21 1.44129 20.6839 0.87868 20.1213C0.316071 19.5587 0 18.7956 0 18V12.75C0 12.5511 0.0790176 12.3603 0.21967 12.2197C0.360322 12.079 0.551088 12 0.75 12Z" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.50084 11.25C7.64149 11.1094 7.83222 11.0304 8.03109 11.0304C8.22996 11.0304 8.42069 11.1094 8.56134 11.25L12.0008 14.6895L15.4403 11.25C15.5095 11.1783 15.5923 11.1212 15.6838 11.0819C15.7753 11.0426 15.8737 11.0219 15.9733 11.021C16.0729 11.0202 16.1716 11.0391 16.2638 11.0768C16.356 11.1146 16.4397 11.1702 16.5101 11.2407C16.5806 11.3111 16.6362 11.3948 16.674 11.487C16.7117 11.5792 16.7306 11.6779 16.7298 11.7775C16.7289 11.8771 16.7082 11.9755 16.6689 12.067C16.6296 12.1585 16.5725 12.2413 16.5008 12.3105L12.5318 16.281C12.4622 16.3508 12.3794 16.4062 12.2883 16.444C12.1972 16.4818 12.0995 16.5013 12.0008 16.5013C11.9022 16.5013 11.8045 16.4818 11.7134 16.444C11.6223 16.4062 11.5395 16.3508 11.4698 16.281L7.50084 12.3105C7.36024 12.1698 7.28125 11.9791 7.28125 11.7802C7.28125 11.5813 7.36024 11.3906 7.50084 11.25Z" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12 1.5C12.1989 1.5 12.3897 1.57902 12.5303 1.71967C12.671 1.86032 12.75 2.05109 12.75 2.25V14.25C12.75 14.4489 12.671 14.6397 12.5303 14.7803C12.3897 14.921 12.1989 15 12 15C11.8011 15 11.6103 14.921 11.4697 14.7803C11.329 14.6397 11.25 14.4489 11.25 14.25V2.25C11.25 2.05109 11.329 1.86032 11.4697 1.71967C11.6103 1.57902 11.8011 1.5 12 1.5Z" />
      </svg>
      {{installationPackageHeading}}
    </div>
    <div class="mt-4" *ngIf="operatingSystem != 'UWP for Windows 10 in S Mode'" id="downloadPackageMsgDiv">
      {{downloadPackageMessage}}
    </div>
    <div class="mt-4 main_section_description" *ngIf="operatingSystem == 'UWP for Windows 10 in S Mode'" id="mainSectionDescriptionDiv">
      <p>
        {{win10SMessage}}
      </p>
      <ol>
        <li class="mt-2">
          <span i18n="@@installation-package.description-point1">If your display device(s) do not have the IPOS for
            Win10S already installed, please install on these devices: {{uwpDefaultPackage}}</span>
        </li>
        <li class="mt-2">
          <span i18n="@@installation-package.description-point2">Select the Custom profile option if you want to install
            a Custom package.</span>
        </li>
        <li class="mt-2">
          <span i18n="@@installation-package.description-point3-profile">You can either enter the <strong> Profile ID
            </strong> (listed below) to proceed or else click on <strong>Choose File </strong> to upload the profile
            content manually (Download or transfer the custom package via USB in order to install it on the display
            device).<div><strong>Note:</strong> An active internet connection is required for proceeding with Profile
              ID.</div></span>
        </li>
      </ol>
      <!-- <div class="mt-4">
      {{win10SFooterMsg}}
    </div> -->
      <div class="mt-4" id="installPackageProfileDiv">
        <h5>{{profileIdHeading}} - {{profileId}}</h5>
      </div>
    </div>
    <div class="button_wrapper" id="installPackageBtnWrapper">
      <button type="button" class="btn btn-primary btn-lg left_icon_btn gtmGenerateNewProfile"
        (click)="generateLastestPushUpdatePackage()">
        {{generatePackageButton}}
      </button>
    </div>
    <div class="button_wrapper" id="installPackageBtnOsLinux">
      <button type="button" *ngIf="operatingSystem == 'Linux'"
        class="btn btn-primary btn-lg left_icon_btn gtmGenerateNewProfile"
        (click)="generateLastestPushUpdatePackage(linuxIposQueryParam)">
        {{linuxIPOSButton}}
      </button>
    </div>
  </section>
</div>
<!-- Generate confirmation popup -->
<iposcen-confirm-dialog #confirmGenModal [popupTitle]="confirmModalTitle" [popupDesc]="confirmModalDesc" [popupAction]="confirmModalCTA" [isProfileGenerate]="true"
      (confirm)="confirmGenerateProfile()"></iposcen-confirm-dialog>
  <section class="generate_status" *ngIf="tabIndex == 1">
    <img alt="generating..." />
    <div class="title" id="generateStatusTitleDiv">{{generatePackageinProgress}}</div>
    <div id="generateStatusPackageNotificationDiv">
      {{packageNotification}}
    </div>
    <button class="btn btn-primary btn-lg mt-3 gtmCreateProfileInstallationPackageOk"
      (click)="packageInstallationInprogess()">{{okButton}}</button>
  </section>

  <section class="main_section installation_content" *ngIf="tabIndex == 2">
    <div class="main_section_headers header_download_img1" id="installPackageHeadingMain">
      <svg class="header_icon" width="24" height="24" viewBox="0 0 24 24" fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M0.75 12C0.948912 12 1.13968 12.079 1.28033 12.2197C1.42098 12.3603 1.5 12.5511 1.5 12.75V18C1.5 18.3978 1.65804 18.7794 1.93934 19.0607C2.22064 19.342 2.60218 19.5 3 19.5H21C21.3978 19.5 21.7794 19.342 22.0607 19.0607C22.342 18.7794 22.5 18.3978 22.5 18V12.75C22.5 12.5511 22.579 12.3603 22.7197 12.2197C22.8603 12.079 23.0511 12 23.25 12C23.4489 12 23.6397 12.079 23.7803 12.2197C23.921 12.3603 24 12.5511 24 12.75V18C24 18.7956 23.6839 19.5587 23.1213 20.1213C22.5587 20.6839 21.7956 21 21 21H3C2.20435 21 1.44129 20.6839 0.87868 20.1213C0.316071 19.5587 0 18.7956 0 18V12.75C0 12.5511 0.0790176 12.3603 0.21967 12.2197C0.360322 12.079 0.551088 12 0.75 12Z" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M7.50084 11.25C7.64149 11.1094 7.83222 11.0304 8.03109 11.0304C8.22996 11.0304 8.42069 11.1094 8.56134 11.25L12.0008 14.6895L15.4403 11.25C15.5095 11.1783 15.5923 11.1212 15.6838 11.0819C15.7753 11.0426 15.8737 11.0219 15.9733 11.021C16.0729 11.0202 16.1716 11.0391 16.2638 11.0768C16.356 11.1146 16.4397 11.1702 16.5101 11.2407C16.5806 11.3111 16.6362 11.3948 16.674 11.487C16.7117 11.5792 16.7306 11.6779 16.7298 11.7775C16.7289 11.8771 16.7082 11.9755 16.6689 12.067C16.6296 12.1585 16.5725 12.2413 16.5008 12.3105L12.5318 16.281C12.4622 16.3508 12.3794 16.4062 12.2883 16.444C12.1972 16.4818 12.0995 16.5013 12.0008 16.5013C11.9022 16.5013 11.8045 16.4818 11.7134 16.444C11.6223 16.4062 11.5395 16.3508 11.4698 16.281L7.50084 12.3105C7.36024 12.1698 7.28125 11.9791 7.28125 11.7802C7.28125 11.5813 7.36024 11.3906 7.50084 11.25Z" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M12 1.5C12.1989 1.5 12.3897 1.57902 12.5303 1.71967C12.671 1.86032 12.75 2.05109 12.75 2.25V14.25C12.75 14.4489 12.671 14.6397 12.5303 14.7803C12.3897 14.921 12.1989 15 12 15C11.8011 15 11.6103 14.921 11.4697 14.7803C11.329 14.6397 11.25 14.4489 11.25 14.25V2.25C11.25 2.05109 11.329 1.86032 11.4697 1.71967C11.6103 1.57902 11.8011 1.5 12 1.5Z" />
      </svg>
      {{installationPackageHeading}}
    </div>

    <div *ngIf="!isWindows10S" id="installationRememberText">
      <p class="mt-4">
        {{installationRememberText}}
      </p>
      <div id="profileNameDiv">
        <span i18n="@@installation-package.download-package.current-installation-text">You can also download the current
          Installation Package for the <strong>{{profileName}}</strong> Profile again at any time from the detail page,
          accessible from your Profile list.</span>
      </div>
      <div class="downloadable_file_name" id="installFullPkgName">{{fullPkgName}}</div>
    </div>

    <div *ngIf="isWindows10S" id="installPkgIsWindows10S">
      <p class="mt-4">{{win10SMessage}}</p>
      <div id="installPkgWindowsPoint1"><span i18n="@@installation-package.download-package.windows-point1">1. If your display devices do not have
          IPOS for Windows* 10 S already installed, please install on these devices: {{uwpDefaultPackage}}.</span></div>
      <div class="mt-3" id="installPkgWindowsPoint2"><span i18n="@@installation-package.download-package.windows-point2">2. Select the Custom profile
          option if you want to install a Custom package.</span></div>
      <div class="mt-3" id="installPkgWindowsPoint3"><span i18n="@@installation-package.download-package.windows-point3-profile">3. You can either
          enter the <strong> Profile ID </strong> (listed below) to proceed or else click on <strong>Choose File
          </strong> to upload the profile content manually (Download or transfer the custom package via USB in order to
          install it on the display device). <div> <strong>Note: </strong> An active internet connection is required for
            proceeding with Profile ID.</div></span></div>
      <div class="mt-3" id="installPkgProfileIdInfo"><strong>{{userProfileId}} - {{profileId}}</strong></div>
    </div>

    <div class="button_wrapper" id="btnWrapperDownloadPkgName">
      <button class="btn btn-primary btn-lg gtmCreateProfDownloadPackage" (click)="downloadPackage()">
        {{downloadPackageName}}
      </button>
    </div>

    <div class="form-group mt-4" id="installPkgFrmGroupDiv">
      <label for="sharePackageLink">{{shareURLText}}</label>:
      <div class="inline_fields" id="installPkgInlineFields">
        <input class="form-control" readonly id="sharePackageLink" #inputToBeCopied value="{{downloadUrl}}" />
        <button class="btn btn-outline-primary gtmCreateProfileInstallationPackageCopy"
          (click)="copyPackageURL(inputToBeCopied)">{{copyText}}</button>
      </div>
    </div>

  </section>